<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  pipelines: { type: Array, required: true },
  activePipelineId: { type: Number, default: null },
});
const emit = defineEmits(['select', 'create']);

const open = ref(false);
const newName = ref('');

const activePipeline = computed(() =>
  props.pipelines.find(p => p.id === props.activePipelineId)
);

function selectPipeline(id) {
  emit('select', id);
  open.value = false;
}

function createPipeline() {
  const name = newName.value.trim();
  if (!name) return;
  emit('create', name);
  newName.value = '';
  open.value = false;
}
</script>

<template>
  <div class="relative">
    <button
      class="flex items-center gap-2 px-3 py-1.5 rounded-md border border-n-strong text-sm text-n-slate-12 hover:bg-n-alpha-1"
      @click="open = !open"
    >
      {{ activePipeline?.name || 'Selecionar pipeline' }}
      <span class="i-lucide-chevron-down size-4 text-n-slate-10" />
    </button>

    <div
      v-if="open"
      class="absolute z-10 mt-1 left-0 min-w-64 bg-n-solid-2 border border-n-weak rounded-md shadow-lg p-2"
    >
      <ul class="mb-2">
        <li
          v-for="pipeline in pipelines"
          :key="pipeline.id"
          class="px-3 py-1.5 rounded cursor-pointer text-sm hover:bg-n-alpha-1"
          :class="{
            'bg-n-brand/10 text-n-brand font-medium':
              pipeline.id === activePipelineId,
          }"
          @click="selectPipeline(pipeline.id)"
        >
          {{ pipeline.name }}
        </li>
      </ul>
      <div class="border-t border-n-weak pt-2 flex gap-1">
        <input
          v-model="newName"
          class="flex-1 px-2 py-1 text-sm rounded border border-n-weak bg-transparent"
          placeholder="Novo pipeline…"
          @keyup.enter="createPipeline"
        />
        <button
          class="px-2 py-1 rounded bg-n-brand text-white text-sm"
          :disabled="!newName.trim()"
          @click="createPipeline"
        >
          Criar
        </button>
      </div>
    </div>
  </div>
</template>
